import React from 'react';
import Propagator from '../../Propagator';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';

const RESET_GAME_MUTATION = gql`
	mutation($gameID: ID!) {
		resetGame(gameID: $gameID) {
			id
			player {
				id
			}
			session {
				id
			}
			data
		}
	}
`;

export default ({ children }) => (
	<Mutation mutation={RESET_GAME_MUTATION} >
		{resetGame => Propagator(children, resetGame)}
	</Mutation>
);
